import { addScriptFile } from "./fetchUtilities";

const scripts = [
    "https://booking.flyfrontier.com/Scripts/lib/mp_linkcode.js",
    "https://frontierairlinesflyfrontiercom.mpeasylink.com/mpel/mpel.js"
];

//This global variable gets added by the above scripts
declare let MP, MpStorage;

let scriptsLoaded = false;

export function initialize(): Promise<any> {
    let promises = [];
    if(!scriptsLoaded) {
        scripts.forEach(x => {
            promises.push(addScriptFile(x));
        });
    }
    
    return Promise.all(promises)
        .then(() => {
            scriptsLoaded = true;

            MP.UrlLang = 'mp_js_current_lang';
            MP.SrcUrl = decodeURIComponent('mp_js_orgin_url');
            MP.oSite = decodeURIComponent('mp_js_origin_baseUrl');
            MP.tSite = decodeURIComponent('mp_js_translated_baseUrl');
            MP.init();
        });
}

export function redirect(hostPrefix) {
    initialize().then(() => {
        if(hostPrefix === "www" && MpStorage && MpStorage.updatePref) {
            MpStorage.updatePref(`${hostPrefix}.flyfrontier.com`, "en");
        }

        window.location.href = `https://${hostPrefix}.flyfrontier.com`;
    });
}

export function translatePage(lang: string, url: string): Promise<any> {
    return initialize().then(() => {
        var tSite = MP.tSite.replace(/(https?:\/\/|\/?$)/g, '');
        url = url.replace(/(https?:\/\/|\/?$)/g, '');
        MP.switchLanguage(tSite.search(url) != -1 ? MP.oSite : url, lang, true);
    })
}

export function initializeLanguageLink(link: HTMLElement): Promise<any> {
    return initialize()
        .then(x => {
            link.onclick = function () {
                var lang = link.getAttribute('data-lang');
                var url = link.getAttribute('data-href');
                translatePage(lang, url);
                //return false;
            }
        });
}

export function getFormattedAmount(numberAmount: number, currencyCode: string) {
    return numberAmount !== undefined && numberAmount.toLocaleString('en-US', { 
        style: 'currency',
        currency: currencyCode || 'USD'
    });
}

export function getFormattedNumber(numberAmount: number) {
    return numberAmount !== undefined && numberAmount.toLocaleString('en-US', { 
        style: 'decimal'
    });
}